import { getCachedHttp } from './http';
import { AuthRepository } from './repositories/auth.repository';
import { BookingRepository } from './repositories/booking.repository';
import { DoctorRepository } from './repositories/doctor.repository';
import { MainRepository } from './repositories/main.repository';
import { MedcenterRepository } from './repositories/medcenter.repository';
import { SearchRepository } from './repositories/search.repository';

const createRepositories = (headers: { cookie: string; setCookie: string }) => {
  const http = getCachedHttp(headers);

  return {
    main: new MainRepository(http),
    search: new SearchRepository(http),
    doctor: new DoctorRepository(http),
    booking: new BookingRepository(http),
    medcenter: new MedcenterRepository(http),
    auth: new AuthRepository(http),
  };
};

export { createRepositories };
